import React, { useEffect, useState } from 'react';
import {
  getSurveyDismissState,
  setSurveyDismissState,
  submitBookingFeedback,
} from '../lib/bookingFeedback';

const RATINGS = [1, 2, 3, 4, 5];

export default function BookingSurvey({ appointmentId, companyId }) {
  const [visible, setVisible] = useState(false);
  const [rating, setRating] = useState(null);
  const [comment, setComment] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!appointmentId) return;
    const prior = getSurveyDismissState(appointmentId);
    if (!prior) {
      setVisible(true);
    } else if (prior === 'submitted') {
      setDone(true);
      setVisible(true);
    }
  }, [appointmentId]);

  if (!visible) return null;

  const dismiss = (state) => {
    setSurveyDismissState(appointmentId, state);
    if (state === 'skipped') {
      setVisible(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!rating) {
      setError('Please select a rating.');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await submitBookingFeedback({
        appointmentId,
        companyId,
        rating,
        comment: comment.trim() || undefined,
      });
      setSurveyDismissState(appointmentId, 'submitted');
      setDone(true);
    } catch (err) {
      setError(err.message || 'Could not submit your feedback.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className='col-xl-12'>
      <div className='card'>
        <div className='card-header'>How was this booking?</div>
        <div className='card-body'>
          {done ? (
            <p className='text-muted mb-0'>Thanks for your feedback.</p>
          ) : (
            <form onSubmit={handleSubmit}>
              <p className='text-muted small mb-3'>
                Your rating helps us improve the booking experience.
              </p>
              <div className='btn-group mb-3' role='group' aria-label='Rating'>
                {RATINGS.map((value) => (
                  <button
                    key={value}
                    type='button'
                    className={`btn btn-sm ${
                      rating === value ? 'btn-primary' : 'btn-outline-primary'
                    }`}
                    onClick={() => setRating(value)}
                    aria-pressed={rating === value}
                  >
                    {value} ★
                  </button>
                ))}
              </div>
              <div className='form-group mb-3'>
                <label className='small text-muted' htmlFor='booking-survey-comment'>
                  Optional comment
                </label>
                <textarea
                  id='booking-survey-comment'
                  className='form-control'
                  rows='3'
                  maxLength={1000}
                  placeholder='Anything we could do better?'
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
              </div>
              {error && <p className='text-danger small'>{error}</p>}
              <div className='d-flex align-items-center gap-2'>
                <button type='submit' className='btn btn-primary btn-sm' disabled={submitting}>
                  {submitting ? 'Sending…' : 'Submit feedback'}
                </button>
                <button
                  type='button'
                  className='btn btn-link btn-sm p-0'
                  onClick={() => dismiss('skipped')}
                >
                  Not now
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
